<template>
  <div class="resetPwd">
    <div class="container main-container hidden-sm-and-down">
      <div class="imgbox">
        <h1 class="title">重置密码</h1>
      </div>
      <div class="pc">
        <div class="containers">
          <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="设置密码:" prop="pass">
              <el-input onkeyup="this.value=this.value.replace(/\s+/g,'')" type="password" v-model="ruleForm.pass" placeholder="8-18位数密码" autocomplete="off" ref="pwd"></el-input>
            </el-form-item>
            <el-form-item label="请输入密码:" prop="checkPass">
              <el-input onkeyup="this.value=this.value.replace(/\s+/g,'')" type="password" v-model="ruleForm.checkPass" placeholder="确认密码" autocomplete="off" ref="pwd2"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button class="btn" @click="submit()">确认</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>

    </div>

    <div class="hidden-md-and-up mob">
           <h1 class="title">重置密码</h1>
           <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <el-form-item  prop="pass">
              <el-input onkeyup="this.value=this.value.replace(/\s+/g,'')" type="password" v-model="ruleForm.pass" placeholder="8-18位数密码" autocomplete="off" ref="pwd"></el-input>
            </el-form-item>
            <el-form-item  prop="checkPass">
              <el-input onkeyup="this.value=this.value.replace(/\s+/g,'')" type="password" v-model="ruleForm.checkPass" placeholder="确认密码" autocomplete="off" ref="pwd2"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button class="btn" @click="submit()">确认</el-button>
            </el-form-item>
          </el-form>
    </div>
  </div>
</template>

<script>
  import {forgetnext_API} from '../request/api'
//   import {prompt_success, prompt_error} from '../common/message'

  export default {
    name: "Resetpwd",
    data() {
      let validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else if (value.length < 8) {
          callback(new Error('密码长度不够'));
        } else if (value.length > 18) {
          callback(new Error('密码最长18位'));
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };
      let validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else if (value.length < 8) {
          callback(new Error('密码长度不够'));
        } else if (value.length > 18) {
          callback(new Error('密码最长18位'));
        } else {
          callback();
        }
      };
      return {
        ruleForm: {
          pass: '',
          checkPass: '',
        },
        rules: {
          pass: [
            {validator: validatePass, trigger: 'blur'}
          ],
          checkPass: [
            {validator: validatePass2, trigger: 'blur'}
          ],
        }
      }
    },
    methods: {
      async submit() {
        let Datalist = {
          "password": this.$refs.pwd.value,
          "password_confirmation": this.$refs.pwd2.value,
        };
        if (this.$refs.pwd.value == '' || this.$refs.pwd2.value == '') {
        this.$message.error("请输入完整信息");
          return false;
        }
        if (!this.$store.state.isLogin) {
        // if (false) {
          this.$message.error('您还没有发送验证码');
          this.$router.push({path: '/ForgotPwd'});
        } else {
        forgetnext_API(Datalist).then((res)=>{
          console.log(res)
            if (res.data.code === 200) {
                this.$message.success("修改成功");
                // localStorage.removeItem("userToken");
                this.$router.push({path: '/Product'});
            }
        })
         
        }
      }
    },
    mounted(){
      console.log(this)
      console.log(this.$store.state.isLogin)
    },
    beforeDestroy(){
      this.$cookies.remove('tokenDate');
      localStorage.removeItem("userToken");
    }
  }
</script>

<style lang="less" scoped>

 .container{
     width: 100%;
     color: #00383F;
     .imgbox{
             width: 60%;
            margin: 0 auto;
            padding-top: 165px;
            h1{
                padding: 6% 0;
            }
            span{
                    display: block;
                    font-size: 18px;
                    margin-bottom: 60px;
            }
     }
     .pc{
         width: 100%;
        margin: 0 auto;
        padding-bottom: 150px;
        .containers{
            max-width: 600px;
            margin: 0 auto;
            .demo-ruleForm{
                width: 70%;
                margin: 0 auto;
            }
            .btn{
                width: 135px;
                height: 40px;
                float: left;
                margin-top: 30px;
                margin-left: 20%;
                background: #00383F;
                color: #fff;
            }
        }
     }
 }

  @media (max-width: 991px) {
    .mob{
      margin: 0 0.6rem;
      padding-top: 1rem;
      padding-bottom: 3rem;
      h1{
        font-size: 0.4rem;
        font-weight: 900;
        padding-bottom: 0.8rem;
      }
        .btn{
       width: 100%;
       background: #00383F;
        border: 1px solid #00383F;
        height: 0.89rem;
        font-weight: 900;
        color: #F8FFFF;
        font-size: 0.33rem;
        border-radius: unset;
     }
    }

     /deep/.el-input__inner::placeholder{
     text-align: left;
     font-size: 0.24rem;
   }
   /deep/.el-input__inner{
     height: 0.83rem;
     border-radius: unset;
   }
   /deep/.el-button{
     padding: unset;
   }
  }
</style>


// WEBPACK FOOTER //
// src/view/ResetPwd.vue